import './scss/productVisualizations.scss';

const ProductVisualizations = () => {

};

export default ProductVisualizations();


// WEBPACK FOOTER //
// ../components/productVisualizations/productVisualizations.js